import(/* webpackMode: "eager" */ "/home/ubuntu/download/69847c45921dc90014b3fc71/apollobits_academy/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69847c45921dc90014b3fc71/apollobits_academy/src/app/courses/components/CourseCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69847c45921dc90014b3fc71/apollobits_academy/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69847c45921dc90014b3fc71/apollobits_academy/src/components/ui/AppIcon.tsx");
